// Api calls for use by Vuex
import AuthWrapper from '../authWrapper';
import envService from '@/services/shared/environmentService.js';

class AgentPortalApiService {
  getBaseUrl () {
    var env = envService.getEnvironment();
    if (env === 'Local') {
      return 'https://agentapi.hawksoft-dev.cloud';
    } else if (env === 'Development') {
      return 'https://agentapi.hawksoft-dev.cloud';
    } else if (env === 'QA') {
      return 'https://agentapi.hawksoft-qa.cloud';
    } else if (env === 'PO') {
      return 'https://agentapi.hawksoft-po.cloud';
    } else if (env === 'Production') {
      return 'https://agentapi.hawksoft.cloud';
    }

    return '<unable to determine api url>';
  }

  async getClientInformation (clientId) {
    var body = {
      command: 'GetGeneralClientInfo',
      getGeneralClientInfo: {
        clientId: parseInt(clientId)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getProfiles (clientId, skipCount) {
    var body = {
      command: 'GetProfileSummaries',
      getProfileSummaries: {
        clientId: parseInt(clientId),
        skipCount: skipCount,
        requestedNumber: 10
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getContacts (clientId, skipCount) {
    var body = {
      command: 'GetClientContacts',
      getClientContacts: {
        clientId: parseInt(clientId),
        skipCount: skipCount
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getProfileDetails (clientId, profileId) {
    var body = {
      command: 'GetProfileSummary',
      getProfileSummary: {
        clientId: parseInt(clientId),
        profileId: parseInt(profileId)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getProfileContacts (clientId, profileId, skipCount) {
    var body = {
      command: 'GetProfileContacts',
      getProfileContacts: {
        clientId: parseInt(clientId),
        profileId: parseInt(profileId),
        skipCount: skipCount
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getPolicies (clientId, skipCount, onlyActive, archivedPolicies) {
    var body = {
      command: 'GetPolicySummaries',
      getPolicySummaries: {
        clientId: parseInt(clientId),
        skipCount: skipCount,
        activePolicies: onlyActive,
        archivedPolicies: archivedPolicies
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getGeneralPolicyInformation (clientId, policyDisplayOrder) {
    var body = {
      command: 'GetPolicyDetails',
      getPolicyDetails: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getLineOfBusinessCoverages (clientId, policyDisplayOrder, lobCode) {
    var body = {
      command: 'GetLineOfBusinessCoverages',
      getLineOfBusinessCoverages: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        code: parseInt(lobCode)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getHazards (clientId, policyDisplayOrder, lobCode) {
    var body = {
      command: 'GetHazards',
      getHazards: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        code: parseInt(lobCode)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getPolicyCoverages (clientId, policyDisplayOrder) {
    var body = {
      command: 'GetPolicyCoverages',
      getPolicyCoverages: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getLineOfBusinessVehicles (clientId, policyDisplayOrder, lobCode, skipCount) {
    var body = {
      command: 'GetVehicles',
      getVehicles: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        code: parseInt(lobCode),
        skipCount: skipCount,
        requestedNumber: 10
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getVehicleDetails (clientId, policyDisplayOrder, lobCode, vehicleId) {
    var body = {
      command: 'GetVehicleDetails',
      getVehicleDetails: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        code: parseInt(lobCode),
        vehicleId: parseInt(vehicleId)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getVehicleCoverages (clientId, policyDisplayOrder, lobCode, vehicleId) {
    var body = {
      command: 'GetVehicleCoverages',
      getVehicleCoverages: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        code: parseInt(lobCode),
        vehicleId: parseInt(vehicleId)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getLineOfBusinessDrivers (clientId, policyDisplayOrder, lobCode, skipCount) {
    var body = {
      command: 'GetLineOfBusinessDrivers',
      getLineOfBusinessDrivers: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        code: parseInt(lobCode),
        skipCount: skipCount,
        requestedNumber: 10
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getLineOfBusinessDriverDetail (clientId, policyDisplayOrder, lobCode, driverId) {
    var body = {
      command: 'GetLineOfBusinessDriverDetail',
      getLineOfBusinessDriverDetail: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        code: parseInt(lobCode),
        driverId: parseInt(driverId)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getSchedules (clientId, policyDisplayOrder, lobCode, type) {
    var body = {
      command: 'GetSchedules',
      getSchedules: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        code: parseInt(lobCode),
        type: type
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getHomeUnderwriting (clientId, policyDisplayOrder, detailView) {
    var body = {
      command: 'GetHomeUnderwriting',
      getHomeUnderwriting: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder),
        detailView: detailView
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getHomeCoverages (clientId, policyDisplayOrder) {
    var body = {
      command: 'GetHomeCoverages',
      getHomeCoverages: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getHomeScheduledProperty (clientId, policyDisplayOrder) {
    var body = {
      command: 'GetHomeScheduledProperty',
      getHomeScheduledProperty: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getHomeEndorsements (clientId, policyDisplayOrder) {
    var body = {
      command: 'GetHomeEndorsements',
      getHomeEndorsements: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }

  async getMoProCoverages (clientId, policyDisplayOrder) {
    var body = {
      command: 'GetMoProCoverages',
      getMoProCoverages: {
        clientId: parseInt(clientId),
        policyOrderNumber: parseInt(policyDisplayOrder)
      }
    };

    const response = await AuthWrapper.post(`${this.getBaseUrl()}/api/request`, body);
    return response;
  }
}

var x = new AgentPortalApiService();
export default x;
